import { Alert } from 'react-native';
import { format, isBefore, parseISO } from 'date-fns';
// A closed account can't be opened again until reopenBlockedUntil, so starting or continuing an application of that type is blocked.
export const getReopenBlockedUntil = (accounts, accountType) => {
    const now = new Date();
    for (const { account } of accounts ?? []) {
        if (account.broker === 'seccl' &&
            account.accountType === accountType &&
            account.status === 'CLOSED' &&
            account.reopenBlockedUntil) {
            const reopenBlockedUntil = parseISO(account.reopenBlockedUntil);
            if (isBefore(now, reopenBlockedUntil)) {
                return reopenBlockedUntil;
            }
        }
    }
    return undefined;
};
export const showReopenBlockedAlert = (reopenBlockedUntil) => {
    Alert.alert('Hold on 💫', `Your trading account has been recently closed. You will be able to open a trading account with us again on ${format(reopenBlockedUntil, 'dd-MM-yyyy')}`);
};
